import { APP_INITIALIZER, LOCALE_ID, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { NZ_I18N } from 'ng-zorro-antd/i18n';
import { pt_BR } from 'ng-zorro-antd/i18n';
import { registerLocaleData } from '@angular/common';
import pt from '@angular/common/locales/pt';
import { FormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { BrowserAnimationsModule, NoopAnimationsModule } from '@angular/platform-browser/animations';
import { NgxPermissionsModule, NgxPermissionsService } from 'ngx-permissions';
import { SharedModule } from './shared/shared.module';
import { CoreModule } from '@core/core.module';
import { AppSharedDataService } from './app-shared-data.service';
import { LocalStorageService } from '@core/local-storage/local-storage.service';
import { UsuarioMeusDados } from '@core/models/usuario';
import { MenuAsideComponent } from '@shared/components/menu-aside/menu-aside.component';
import { MenuHeaderComponent } from '@shared/components/menu-header/menu-header.component';
import { SubHeaderComponent } from '@shared/components/sub-header/sub-header.component';
import { AppSignalDataService } from './app-signal-data.service';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { EntidadeModule } from '@modules/entidade/entidade.module';
import { ParametrizacaoModule } from '@modules/parametrizacao/parametrizacao.module';
import { RelatoriosModule} from '@modules/relatorios/relatorios.module';

registerLocaleData(pt);

@NgModule({
  declarations: [
    AppComponent,
    MenuAsideComponent,
    MenuHeaderComponent,
    SubHeaderComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    NoopAnimationsModule,
    AppRoutingModule,
    FormsModule,
    HttpClientModule,
    NgxPermissionsModule.forRoot(),
    CoreModule,
    SharedModule,
    FontAwesomeModule,
    EntidadeModule,
    ParametrizacaoModule,
    RelatoriosModule
  ],
  providers: [
    AppSharedDataService,
    AppSignalDataService,
    NgxPermissionsService,
    { provide: NZ_I18N, useValue: pt_BR },
    { provide: LOCALE_ID, useValue: 'pt-BR' },
    {
      provide: APP_INITIALIZER,
      useFactory: loadPermissions,
      deps: [NgxPermissionsService, LocalStorageService],
      multi: true
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule {

 }

export function loadPermissions(permissionService: NgxPermissionsService, localStorageService: LocalStorageService) {
  return () => {
    let userData = <UsuarioMeusDados>JSON.parse(localStorageService.getItem('currentUser'));
    if(userData?.perfil?.perfil)
    permissionService.addPermission(userData.perfil?.perfil);
  }

}
